/**
 * Flag Facade
 *
 * Stable API surface for flag operations.
 * Aggregates actions for presentation layer consumption.
 * @agentic connections
 */

import type { MedplumClient } from "@medplum/core";
import type { Flag } from "@medplum/fhirtypes";
import { upsertFlag, type UpsertFlagInput } from "@benchmark/core/actions";
import { CONFIG } from "@/app/config";

/**
 * Creates a Flag facade instance bound to a MedplumClient.
 * @agentic connections
 */
export function createFlagFacade(medplum: MedplumClient) {
  return {
    /**
     * Create or update a flag.
     * @agentic connections
     */
    upsert: (input: UpsertFlagInput): Promise<Flag> => {
      return upsertFlag(medplum, {
        benchmarkOrganizationId: CONFIG.VITE_BENCHMARK_ORGANIZATION_ID,
        ...input,
      });
    },
  };
}
